export default __webpack_public_path__ + "static/media/surf.f04a601f.gif";